import { PersonBlock, ResponsiveTableRow } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { DmcResponsiveTable } from '../../../common/DmcResponsiveTable'
import { getLastPathElement } from '../../../../util/StringUtil'

export default function ModifyCtrPersonTable({ modifiedPersons }) {
  const { t } = useTranslation()

  return (
    <DmcResponsiveTable
      atSizeColumns={{
        default: {
          labels: [
            t('role.label', 'Role'),
            t('person.label', 'Person'),
            t('ctr.summary.createTreePerson.tableHeadings.newPid', 'New Pid'),
          ],
        },
      }}
      totalColumnCount={3}
    >
      {modifiedPersons.map((modifiedPerson) => {
        return (
          <ResponsiveTableRow
            key={modifiedPerson.role}
            name={modifiedPerson.role}
            column1={modifiedPerson.role}
            column2={
              <PersonBlock
                size="md"
                avatarProps={{
                  sex:
                    modifiedPerson.person.gender.type &&
                    getLastPathElement(modifiedPerson.person.gender.type).toLowerCase(),
                }}
                name={modifiedPerson.person.names[0].nameForms[0].fullText}
                details={modifiedPerson.person.dmc2OldPid}
              />
            }
            column3={
              !modifiedPerson.person.dmc2NewPid
                ? t('ctr.summary.createTreePerson.samePids', 'Same')
                : modifiedPerson.person.dmc2NewPid
            }
          />
        )
      })}
    </DmcResponsiveTable>
  )
}
